export default "__VITE_ASSET__BXbsHL4Z__"